module.exports = __webpack_public_path__ + "img/jiaosexuanze.b75779bc.png";